export enum TextAlignmentEnum {
    Left = 'start',
    Center = 'center',
    Right = 'end'
}
